import { TranslateModule } from '@ngx-translate/core';
import { IBookingModel } from '@services/api/booking/booking-model.interface';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { RippleModule } from 'primeng/ripple';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, input, Output, output } from '@angular/core';
import { BookingActionEvent } from '../../models/booking-detail.model';

@Component({
  selector: 'app-booking-page-header',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, RippleModule, MessageModule],
  templateUrl: './booking-page-header.component.html'
})
export class BookingPageHeaderComponent {
  @Input() booking: IBookingModel | null = null;
  @Input() isSaving = false;
  @Input() hasChanges = false;
  @Output() actionEvent = new EventEmitter<BookingActionEvent>();

  readonly canLinkChain = input(false);
  readonly linkChain = output<void>();

  onLinkChain(): void {
    this.linkChain.emit();
  }

  /**
   * Handle back button click
   */
  onBack(): void {
    this.actionEvent.emit({ action: 'back' });
  }

  /**
   * Handle save button click
   */
  onSave(): void {
    if (!this.booking || !this.hasChanges) return;
    this.actionEvent.emit({ action: 'save', booking: this.booking });
  }

  /**
   * Handle cancel button click
   */
  onCancel(): void {
    this.actionEvent.emit({ action: 'cancel' });
  }
}
